import * as Service from '../services/c360_api';
import * as Transformer from '../Transformer';

export default {
  /**
   *
   * @param commit
   * @param state
   * @param page
   * @param limit
   * @returns {Promise<void>}
   */
  async getCustomers({ commit, state }, { page = 1, limit = 10 }) {
    const response = await Service.getAllRFMAnalysis({ page, limit, filters: state.customers_filter });
    commit('setProperty', {
      property: 'customers',
      payload: response.payload,
    });
    commit('setProperty', { property: 'customers_pagination', payload: response.metadata });
  },

  /**
   *
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchRfmCounts({ commit }) {
    const response = await Service.fetchRfmCounts();
    commit('setProperty', { property: 'rfm_counts', payload: response });
  },

  /**
   *
   * @param commit
   * @param customerId
   * @returns {Promise<void>}
   */
  async fetchCustomer({ commit }, customerId) {
    const response = await Service.fetchCustomer(customerId);
    const rfm = await Service.fetchCustomerRFM(customerId);
    commit('setProperty', { property: 'customer', payload: response });
    commit('setProperty', { property: 'customerRFM', payload: rfm.payload });
  },
};
